import { Handle, Position} from "reactflow";
import styles from '../styles/nodes.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHashtag, faX} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from 'react-i18next';

export default function ValueNode({id, data}) {
    const { t } = useTranslation();
    return (
        <div className={`${styles.scratch_block_value} shadow`}>
            <div className="d-flex flex-row w-100">
                <div className={'d-flex'}>
                    <div className={styles.scratch_block_type_icon_value}>
                        <FontAwesomeIcon icon={faHashtag} color="white"/>
                    </div>
                    <div className={styles.scratch_block_type}>{t('operations.nodes.value')}</div>
                </div>
                <div className={'px-2 pointer-event'} onClick={() => {
                    if (typeof data.onDeleteNode === 'function') {
                        data.onDeleteNode(id);
                    } else {
                        data.setNodes((prev) => [...prev.filter((node) => node.id !== id)]);
                        data.setDeletionList((prev) => [...prev, id]);
                    }
                }}>
                    <FontAwesomeIcon icon={faX} color={'#999'} size={'sm'}/>
                </div>
            </div>
            <div>{data.label}</div>
            <Handle type="source" position={Position.Bottom} id="output"/>
        </div>
    )
}